import React, { memo, useContext } from 'react';
import styled from 'styled-components';

import { AppContext } from '@prisjakt/ui-app-context';

type ProductImageProps = {
  fallback?: string;
  src?: string | null;
  name?: string | null;
  className?: string;
};

const ProductImage = ({
  fallback,
  src,
  name,
  className,
}: ProductImageProps) => {
  const { market = { cdn: 'https://cdn.pji.nu' } } = useContext(AppContext);

  const fallbackImage =
    fallback && !/^https?:\/\//.test(fallback)
      ? market.cdn + fallback
      : fallback;

  const productImage =
    src || fallbackImage || `${market.cdn}/product/standard/280/0.jpg`;

  return (
    <Image
      src={productImage}
      alt={name || ''}
      className={className}
      $fallback={Boolean(!src && fallback)}
    />
  );
};

type ImageProps = {
  $fallback: boolean;
};

const Image = styled.img<ImageProps>`
  opacity: ${p => (p.$fallback ? 0.2 : 1)};
`;

export default memo(ProductImage);
